import CustomReactSelect from "../../../CustomReactSelect/CustomReactSelect";
import InputAndSelect from "../InputAndSelect/InputAndSelect";
import { DeleteIcon } from "../../../../assets/icons";
import "./OriginSection.scss";

const OriginSection = ({
  originNo,
  origin,
  tipoJson,
  headers,
  handleTipoChange,
  handleSelectChange,
  handleInputChange,
  handleKeyChange,
  handleDeleteOrigin,
}) => {
  const onSelectChange = (option, label) => {
    handleSelectChange("origin", option, label, origin?.id);
  };

  const onInputChange = (e, label) => {
    handleInputChange(e, "origin", label, origin?.id);
  };

  const onTipoChange = (option) => {
    handleTipoChange("origin", option, origin?.id);
  };

  const onKeyChange = (e) => {
    handleKeyChange(e, origin?.id);
  };

  const onDeleteOrigin = () => {
    // console.log("originNo--->>", originNo, '--->>>', origin);
    handleDeleteOrigin(origin?.id);
  };

  return (
    <div className="modal-upload-section-wrapper">
      <div className="origin-delete-wrapper">
        <button onClick={onDeleteOrigin}>
          <DeleteIcon />
        </button>
      </div>
      <InputAndSelect
        options={headers}
        initSelect={origin?.selectedComune}
        initInput={origin?.comune?.value}
        displayAttr="value"
        label="Comune o sito"
        attr={"comune"}
        placeholder="Seleziona il Comune"
        onChange={onSelectChange}
        onInputChange={onInputChange}
      />
      <CustomReactSelect
        options={tipoJson}
        value={origin?.selectedTipo}
        displayAttr={"label"}
        label="Tipo"
        placeholder="Seleziona il tipo"
        onChange={onTipoChange}
      />
      <InputAndSelect
        options={headers}
        initSelect={origin?.selectedValore}
        initInput={origin?.valore?.value}
        displayAttr="value"
        label="Valore"
        attr={"valore"}
        placeholder="Seleziona il valore"
        onChange={onSelectChange}
        onInputChange={onInputChange}
      />
      <div className="chiave-wrapper">
        <label className="chiave-label" htmlFor="chiave">
          Chiave
        </label>
        <input id="chiave" name="chiave" type="text" value={origin?.chiave} onChange={onKeyChange} />
      </div>
    </div>
  );
};

export default OriginSection;
